import { Chip } from "@mui/material";
import { Box, Button, Card } from "app/pages/admin/components";
import Paragraph from "app/pages/admin/components/Paragraph";
import Span from "app/pages/admin/components/Span";
import { CollectionType, QuestionType } from "app/types";
import { useEffect } from "react";
import { getFragrance, getQuestionType } from "./QuestionsCloneList";

type DisplayQuestionProps = {
  question: QuestionType;
  collections: CollectionType[];
  translate: any;
};
const DisplayQuestion = ({
  question,
  collections,
  translate,
}: DisplayQuestionProps) => {
  // useEffect(() => {
  // }, []);
  return (
    <Card key={question.questionId} style={styles.questionContainer}>
      <Card.Title>
        {`${translate("screenApp.results.question")}: ${
          question.question?.quest
        }`}
      </Card.Title>
      <Card.Body>
        {question.rightAnswer && (
          <Paragraph style={styles.rightAnswer}>
            <Paragraph.Bold>
              {translate("screenApp_results_answer_true")}:
            </Paragraph.Bold>{" "}
            {question.rightAnswer}
          </Paragraph>
        )}
        <Paragraph style={styles.rightAnswer}>
          <Paragraph.Bold>
            {translate("screens_quiz_labels_answer")}:
          </Paragraph.Bold>{" "}
          {question.answers.length > 0 &&
            question.answers.map((answer, index) => (
              <Span key={index}>
                {answer.answer?.label}{" "}
                {index < question.answers.length - 1 && "/"}{" "}
              </Span>
            ))}
        </Paragraph>
        <Box
          style={{
            display: "grid",
            gridTemplateColumns: "50% 50%",
            gap: "5px",
            padding: "0 5px",
            alignItems: "start",
            width: "100%",
          }}
        >
          <Paragraph style={styles.rightAnswer}>
            <Paragraph.Bold>
              {translate("screens_collectionDevice_table_fragrance")}:
            </Paragraph.Bold>{" "}
            {getFragrance(question.fragranceId, collections)}
          </Paragraph>
          <Paragraph style={styles.rightAnswer}>
            <Paragraph.Bold>
              {translate("screenApp_quiz_questionType")}:
            </Paragraph.Bold>{" "}
            {getQuestionType(question.type)}
          </Paragraph>
          <Paragraph style={styles.rightAnswer}>
            <Paragraph.Bold>
              {translate("screens_quiz_list_created")}:
            </Paragraph.Bold>{" "}
            {question.createdAt
              ? new Date(question?.createdAt).toLocaleDateString("pt-BR", {
                  day: "numeric",
                  month: "numeric",
                  year: "numeric",
                  hour: "numeric",
                  minute: "numeric",
                })
              : ""}
          </Paragraph>
          <Paragraph style={styles.rightAnswer}>
            <Paragraph.Bold>
              {translate("screens_quiz_list_updated")}:
            </Paragraph.Bold>{" "}
            {question.updatedAt
              ? new Date(question.updatedAt).toLocaleDateString("pt-BR", {
                  day: "numeric",
                  month: "numeric",
                  year: "numeric",
                  hour: "numeric",
                  minute: "numeric",
                })
              : ""}
          </Paragraph>
        </Box>
      </Card.Body>
    </Card>
  );
};

const styles: Record<string, React.CSSProperties> = {
  questionContainer: {
    marginBottom: "20px",
    borderRadius: "8px",
    paddingBottom: "8px",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
  },
  rightAnswer: {
    fontSize: "16px",
    margin: "5px 0",
  },
};

export default DisplayQuestion;
